import { render, staticRenderFns } from "./StudioForm.vue?vue&type=template&id=06c6c5c0"
import script from "./StudioForm.vue?vue&type=script&lang=js"
export * from "./StudioForm.vue?vue&type=script&lang=js"
import style0 from "./StudioForm.vue?vue&type=style&index=0&id=06c6c5c0&prod&lang=scss"
import style1 from "./StudioForm.vue?vue&type=style&index=1&id=06c6c5c0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports